"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
exports.__esModule = true;
var WebExtractorWrapper_1 = require("./WebExtractorWrapper");
var Field = function () {
  function Field(init) {
    Object.assign(this, init);
  }
  Field.logCastingError = function (val, err) {
    console.log("FIELD CASTING FAILED! Class: " + this.constructor.name + ", Instance: " + JSON.stringify(this) + " Website value: " + val + ", Error: " + err);
  };
  Field.prototype.extractFromPage = function () {
    return __awaiter(this, void 0, void 0, function () {
      var websiteValue, fieldName;
      var _this = this;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!this.selector && !this.extractFn) {
              return [2, undefined];
            }
            if (!this.selector) return [3, 4];
            if (!(this.selector.css || this.selector.xpath || this.selector.microPath)) return [3, 3];
            fieldName = this.name || extractorContext.uuid();
            return [4, WebExtractorWrapper_1["default"].extract([{
              selector: this.selector,
              fieldName: fieldName,
              regExp: this.regExp,
              regExpReplace: this.regExpReplace,
              required: this.required,
              returnArray: this.returnArray
            }], this.rowSelector)];
          case 1:
            return [4, _a.sent()];
          case 2:
            websiteValue = _a.sent();
            if (websiteValue && websiteValue.length >= 1) {
              websiteValue = websiteValue[0][fieldName];
            } else {
              return [2, undefined];
            }
            _a.label = 3;
          case 3:
            return [3, 7];
          case 4:
            if (!this.extractFn) return [3, 6];
            return [4, extractorContext.execute(this.extractFn)];
          case 5:
            websiteValue = _a.sent();
            if (websiteValue === null || websiteValue === undefined) {
              return [2, undefined];
            }
            if (Array.isArray(websiteValue)) {
              websiteValue = extractorContext.lodash.flatten(websiteValue.map(function (q) {
                return _this.regExp ? WebExtractorWrapper_1["default"].applyRe({
                  re: new RegExp(_this.regExp, "g"),
                  replace: _this.regExpReplace
                }, q) : q;
              }));
            } else {
              websiteValue = this.regExp ? WebExtractorWrapper_1["default"].applyRe({
                re: new RegExp(this.regExp, "g"),
                replace: this.regExpReplace
              }, websiteValue)[0] : websiteValue;
            }
            return [3, 7];
          case 6:
            throw Error("Field doesn't have any extraction method specified!");
          case 7:
            if (websiteValue === null || websiteValue === undefined) {
              return [2, undefined];
            }
            if (!Array.isArray(websiteValue)) {
              websiteValue = [websiteValue];
            }
            return [2, websiteValue];
        }
      });
    });
  };
  return Field;
}();
exports["default"] = Field;